const buttonMinus = document.getElementById("buttonMinus");
const buttonPlus = document.getElementById("buttonPlus");
const humidityValue = document.getElementById("humidityValue");
const heatMapHead = document.getElementById("heatMapHead");
const heatMapBody = document.getElementById("heatMapBody");
const humidityPromoButton = document.getElementById("humidityPromoButton")
const minHumidity = 20;
const maxHumidity = 50;
const drops = [].map.call(document.querySelectorAll('[data-humidity-drop]'), el => el)

let hueBackgroundColor = 188;
let hueGradientColor = 41;

humidityPromoButton.addEventListener('click', e => {
  incrimentHumidity();
    e.target.style.display = 'none'
})

buttonMinus.addEventListener("click", decrementHumidity);
// buttonPlus.addEventListener("click", incrimentHumidity);


let counterInterval
buttonPlus.addEventListener('click', e => {
  incrimentHumidity()
})
buttonPlus.addEventListener('mousedown', e => {
  counterInterval = setInterval(function() {
    incrimentHumidity();
  }, 100)
})

buttonMinus.addEventListener('mousedown', e => {
  counterInterval = setInterval(function() {
    decrementHumidity()
  }, 100)
})
buttonMinus.addEventListener('click', e => {
  decrementHumidity()
})

document.addEventListener('mouseup', e => {
  clearInterval(counterInterval)
})

showDrops(0)

function showDrops(humidity) {
    const v = (humidity - minHumidity) / (maxHumidity - minHumidity)
    const step = (maxHumidity - minHumidity)/drops.length
    const dropsCount = Math.ceil(drops.length * v)

    drops.forEach((drop, idx) => {
      if(idx >= dropsCount) {
        drop.style.display = 'none'
      } else {
        drop.style.display = 'block'
      }
    })
}

function decrementHumidity() {
  let currentHumidity = Number(humidityValue.innerText);

  if (currentHumidity === minHumidity) return false;

  hueBackgroundColor += 4;
  hueGradientColor += 1;

  humidityValue.innerText = currentHumidity - 1;

    showDrops(currentHumidity)

    changeHueHeatMap(hueBackgroundColor, hueGradientColor);
}

function incrimentHumidity() {
  let currentHumidity = Number(humidityValue.innerText);

  if (currentHumidity === maxHumidity) return false;

  hueBackgroundColor -= 4;
  hueGradientColor -= 1;

  humidityValue.innerText = currentHumidity + 1;

  showDrops(currentHumidity)

  changeHueHeatMap(hueBackgroundColor, hueGradientColor);
}

function changeHueHeatMap(hueBackgroundColor, hueGradientColor) {
  heatMapHead.style.background = `radial-gradient(
        94.89px at 50.47% 32.94%,
        hsl(${hueGradientColor}, 84%, 55%) 0%,
        rgba(237, 177, 45, 0) 100%
      ), hsl(${hueBackgroundColor}, 86%, 39%)`;
  heatMapBody.style.background = `radial-gradient(
        84.56px at 50.29% 73.79%,
        hsl(${hueGradientColor}, 84%, 55%) 0%,
        rgba(237, 177, 45, 0) 100%
      ),
      radial-gradient(
        83.45px at 76.92% 33.82%,
        hsl(${hueGradientColor}, 84%, 55%) 0%,
        rgba(237, 177, 45, 0) 100%
      ),
      radial-gradient(
        92.35px at 25.74% 32.94%,
        hsl(${hueGradientColor}, 84%, 55%) 0%,
        rgba(237, 177, 45, 0) 100%
      ),
      hsl(${hueBackgroundColor}, 86%, 39%)`;
}
